/** Normalize legacy localized backup types while preserving unknown API values. */
export function normalizeBackupType(type: unknown): 'FILES' | 'POSTGRESQL' | null {
  const value = String(type ?? '')
    .trim()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toUpperCase();

  if (['FILES', 'ARQUIVOS', 'ARCHIVOS'].includes(value)) return 'FILES';
  if (['POSTGRESQL', 'POSTGRES', 'POSTGRESQL DATABASE'].includes(value)) return 'POSTGRESQL';
  return null;
}
